import { useEffect } from 'react';
import { onAuthChange } from '../firebase/auth';
import { getUserRole, getUserData } from '../firebase/database';
import { useAuthStore } from '../store';

export const useAuthListener = () => {
  const { setUser, setUserRole, setUserData, setLoading, clearUser } = useAuthStore();

  useEffect(() => {
    const unsub = onAuthChange(async (user) => {
      if (user) {
        setUser(user);
        try {
          const [role, data] = await Promise.all([
            getUserRole(user.uid),
            getUserData(user.uid)
          ]);
          setUserRole(role);
          setUserData(data);
        } catch {
          setUserRole('user');
        }
      } else {
        clearUser();
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);
};
